/* tslint:disable jsx-no-lambda */

import * as classnames from 'classnames'
import { Formik } from 'formik'
import * as React from 'react'
import * as Yup from 'yup'
import { EXPIRATION_DATE, NUMBER_OF_RIDES, PERMANENT, RECURRING, REJECT, TEMPORARY } from '../../state/constants/'
import Modal from '../ui/Modal'
import Error from './Error'
import LimitedTime from './LimitedTime'
import MembershipStatus from './MembershipStatus'
import MembershipUserInfo from './MembershipUserInfo'
import NumberOfRides from './NumberOfRides'
import Recurring from './Recurring'
import RequestType from './RequestType'

class MembershipSettings extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      requestTypeComponent: '',
      requestType: '',
      error: '',
      EligibilityData: {}
    }
  }

  public toggleComponent = (value: string) => () => {
    this.setState({ requestTypeComponent: value })
  }

  public chooseRequestType = (requestType: string) => () => {
    if (requestType !== PERMANENT) {
      this.setState({
        requestType,
        requestTypeComponent: ''
      })
      return null
    }
    this.setState({ requestType })
    return null
  }

  public setEligibilityData = (EligibilityData: any) => {
    if (Object.keys(EligibilityData).length === 0) {
      return null
    }
    this.setState({ EligibilityData })
    return null
  }

  public applyEligibilityForService = () => {
    this.props.MembershipRequestEligibility(this.state.EligibilityData)
  }

  public render() {
    const active = this.state.requestType === PERMANENT
    return (
      <Modal>
        <div className='flex relative membership-modal-wrap'>
          <div className='membership-modal flex'>
            <div className='col-8'>
              <MembershipUserInfo membershipInfo={this.props.selectedMembership} />
            </div>
            <Formik
              initialValues={{
                eligibilityService: '',
                timeSetting: ''
              }}
              validationSchema={Yup.object().shape({
                eligibilityService: Yup.string().required(),
                timeSetting: Yup.string().when('eligibilityService', {
                  is: (eligibilityService: string) => eligibilityService === 'Permanent',
                  then: Yup.string().required()
                })
              })}
              onSubmit={(values, actions) => {
                actions.setSubmitting(false)
              }}
              render={(props: any) => (
                <form
                  onSubmit={props.handleSubmit}
                  className='col-4 bg-light-grey5 p3 flex flex-wrap flex-column items-start relative'
                >
                  {this.props.error && <Error />}
                  <div className='Title h5 font-dark-grey'>Eligibility for the service</div>
                  <div className='bb-grey6 mt2 col-12 pb1'>
                    <div className='RequestType pr2'>
                      <RequestType
                        state={this.state.requestType === PERMANENT}
                        title={'Permanent'}
                        action={this.chooseRequestType(PERMANENT)}
                        handleSetValue={props.setFieldValue}
                        timeSetting={props.values.timeSetting}
                      />
                    </div>
                    <div className='pr2 mt2'>
                      <RequestType
                        state={this.state.requestType === TEMPORARY}
                        title={'Temporary'}
                        action={this.chooseRequestType(TEMPORARY)}
                        handleSetValue={props.setFieldValue}
                        timeSetting={props.values.timeSetting}
                      />
                    </div>
                    <div className='pr2 mt2'>
                      <RequestType
                        state={this.state.requestType === REJECT}
                        title={'Reject'}
                        action={this.chooseRequestType(REJECT)}
                        handleSetValue={props.setFieldValue}
                        timeSetting={props.values.timeSetting}
                      />
                    </div>
                  </div>
                  <div
                    className={classnames('col-12 relative mt2', {
                      inactive: !active
                    })}
                  >
                    {!active && <div className='absolute top-0 left-0 right-0 bottom-0 z10' />}
                    <LimitedTime
                      isOpen={this.state.requestTypeComponent === EXPIRATION_DATE}
                      onToggle={this.toggleComponent(EXPIRATION_DATE)}
                      onSetDateData={this.setEligibilityData}
                      handleSetValue={props.setFieldValue}
                    />
                    <Recurring
                      isOpen={this.state.requestTypeComponent === RECURRING}
                      onToggle={this.toggleComponent(RECURRING)}
                      onSetDateData={this.setEligibilityData}
                      handleSetValue={props.setFieldValue}
                    />
                    <NumberOfRides
                      isOpen={this.state.requestTypeComponent === NUMBER_OF_RIDES}
                      onToggle={this.toggleComponent(NUMBER_OF_RIDES)}
                      onSetDateData={this.setEligibilityData}
                      handleSetValue={props.setFieldValue}
                    />
                  </div>

                  <MembershipStatus
                    status={this.props.updatingStatus}
                    toggleModal={this.props.toggleMembershipModal}
                    apply={this.applyEligibilityForService}
                  />
                </form>
              )}
            />
          </div>
        </div>
      </Modal>
    )
  }
}

export default MembershipSettings



// WEBPACK FOOTER //
// ./src/components/membership-request/MembershipSettings.tsx